import WidgetModule from "@eisinc/Overrides/Widgets/AccountSettings/DefaultBillingAddress";

export * from "@eisinc/Overrides/Widgets/AccountSettings/DefaultBillingAddress";

export default WidgetModule;
